// extracted by mini-css-extract-plugin
module.exports = {"Description":"AboutDescription_Description__3bMvj"};